import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateResource } from '../../../../../redux/actions/resources'
import { formValidator, resetFormValidator } from '../../../../../redux/actions/validator'
import { IRootState } from '../../../../../redux/types'
import { IResource } from '../../models/resource'

function useEditHandleSubmit(resource: IResource) {
  const dispatch = useDispatch()
  const { isValidForm } = useSelector((state: IRootState) => state.validator)

  useEffect(() => {
    if (isValidForm) {
      dispatch(resetFormValidator())

      const resourceToUpdate = {
        ...resource,
        brand: resource.brand ? { id: resource.brand.id } : null,
        role: resource.role ? { id: resource.role.id } : null,
        visibility: resource.visibility && { id: resource.visibility.id },
        line: resource.line ? { id: resource.line.id } : null,
        categoryIds: resource.categories ? resource.categories.map((category: any) => category.id) : null,
        resourcetypeIds: resource.resourcetypes ? resource.resourcetypes.map((resourcetype: any) => resourcetype.id) : null
      }

      dispatch(updateResource(resourceToUpdate))
    }
  }, [isValidForm])

  const handleSubmit = () => {
    dispatch(
      formValidator({
        id: [resource.id, 'numeric'],
        brands: [resource.brand, 'notempty'],
        languages: [resource.languages, 'notempty'],
        countries: [resource.countries, 'notempty'],
        role: [resource.role, 'notempty'],
        visibility: [resource.visibility, 'notempty'],
        resourcetypes: [resource.resourcetypes, 'notempty']
      })
    )
  }

  return { handleSubmit }
}

export default useEditHandleSubmit
